import type { SVGProps } from 'react';

const SvgAnnotationLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6 19c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l12-12a.996.996 0 1 1 1.41 1.41l-12 12c-.2.2-.45.29-.71.29z"
    />
  </svg>
);
export default SvgAnnotationLine;
